<template>
  <div class="lg:hidden fixed top-20 md:top-25 z-3">
    <button
      class="py-3 px-2 w-6 h-4 bg-primary-color rounded-3xl flex items-center justify-center"
      @click="onClick"
    >
      <i
        class="pi text-xl text-white"
        :class="[direction === 'left' ? 'pi-angle-left' : 'pi-angle-right']"
      />
    </button>
  </div>
</template>

<script>
export default {
  name: 'DrawerToggleButton',
  props: {
    direction: {
      type: String,
      required: true,
      validator: (value) => ['left', 'right'].includes(value),
    },
    onClick: {
      type: Function,
      required: true,
    },
  },
};
</script>
